module.exports = __webpack_public_path__ + "img/banner1.149ec80e.jpg";